import { IBinaryConfig } from '@/features/binaryConfig';
import { CheckBinaryConfig } from '@/features/binaryConfig/check';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useSecureStorage } from '@/hooks/useSecureStorage';
import { useAppStore } from '@/shared/stores/app';
import { createContext, useState } from 'react';
import { EnumOfflineMode, FEED_BINARY_CONFIG, FEED_OFFLINE_MODE, IS_BINARY } from '../../constants';

interface IContextData {
  theme: string | null;
}

export const BinaryConfigContext = createContext({} as IContextData);

export function BinaryConfigProvider({ children }: { children: React.ReactNode }) {
  const { backendLoaded } = useAppStore();

  const { state: binaryConfig } = useSecureStorage<IBinaryConfig | null>(FEED_BINARY_CONFIG, null);
  const [offlineMode] = useLocalStorage<EnumOfflineMode | null>(FEED_OFFLINE_MODE, null);

  const [authored, setAuthored] = useState(false);

  function handleAuthored() {
    setAuthored(true);
  }

  // Config de banco não é mais pré-requisito de boot em nenhum canal — o fluxo novo autentica primeiro
  // (sapId/email/senha, via router) e só então provisiona o banco (flow/desktop). Se já existe config
  // salva de uma sessão anterior, valida o canal de versão antes de liberar.
  if (IS_BINARY && offlineMode === null && binaryConfig && !authored && !backendLoaded) {
    return <CheckBinaryConfig onSuccess={handleAuthored} />;
  }

  return <BinaryConfigContext.Provider value={{ theme: 'value' }}>{children}</BinaryConfigContext.Provider>;
}
